module.exports = __webpack_public_path__ + "images/8a2b10ea.img1-kor.png";


//////////////////
// WEBPACK FOOTER
// ./images/indexV2/img1-kor.png
// module id = 397
// module chunks = 0